import { render, staticRenderFns } from "./dkim.vue?vue&type=template&id=130d5cc4&scoped=true&"
import script from "./dkim.vue?vue&type=script&lang=js&"
export * from "./dkim.vue?vue&type=script&lang=js&"
import style0 from "./dkim.vue?vue&type=style&index=0&id=130d5cc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d5cc4",
  null
  
)

export default component.exports